module.exports = __webpack_public_path__ + "img/home_menu_7_default.88126a2c.png";